<template>
  <div class="ding-regimeList">
    <div class="ding-regimeList-tit">规章制度</div>
    <ul>
      <!-- <a v-for="item in fileList" :key="item.id" :href="item.fileUrl" target="_blank"> -->
        <li  v-for="item in fileList" :key="item.id" @click="toPath(item.fileUrl, item, 0)" >
          <!-- <li
              v-for="item in fileList"
              :key="item.id" @click="preview(item)"> -->
            <div class="ding-regimeList-left">
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/PDF_icon.svg" alt="">
            </div>
            <div class="ding-regimeList-right">
              <p class="ding-regimeList-p1"><span>{{item.fileName}}</span>.pdf</p>
              <!-- <p class="ding-regimeList-p1">
                <pdf src="./static/pdf/%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E9%87%87%E8%B4%AD%E7%99%BD%E7%9A%AE%E4%B9%A6V2.0.pdf"></pdf>
              </p> -->
              <p class="ding-regimeList-p2">{{item.time}}</p>
            </div>
        </li>
      <!-- </a> -->
      <!-- <li @click="toPath('http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/AR_T_CP%E2%80%A200_001_V2.0%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E9%87%87%E8%B4%AD%E6%8B%9B%E6%A0%87%E7%AE%A1%E7%90%86%E5%88%B6%E5%BA%A6V2.0.pdf')">
        <div class="ding-regimeList-left">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/PDF_icon.svg" alt="">
        </div>
        <div class="ding-regimeList-right">
          <p class="ding-regimeList-p1"><span>AR_T_CP•00_001_V2.0复星集团采购招标管理制度V2.0</span>.pdf</p>
          <p class="ding-regimeList-p2">2020-08-07</p>
        </div>
      </li>

      <li @click="toPath('http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/AR_S_CP%E2%80%A200_005_V1.0%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E9%87%87%E8%B4%AD%E6%8B%9B%E6%A0%87%E7%AE%A1%E7%90%86%E7%BB%86%E5%88%99V1.0.pdf')">
        <div class="ding-regimeList-left">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/PDF_icon.svg" alt="">
        </div>
        <div class="ding-regimeList-right">
          <p class="ding-regimeList-p1"><span>AR_S_CP•00_005_V1.0复星集团采购招标管理细则V1.0</span>.pdf</p>
          <p class="ding-regimeList-p2">2020-08-07</p>
        </div>
      </li>
      <li @click="toPath('http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/CP_001_V1.0%20FOSUN%20Supplier%20Code%20of%20Conduct%20V1.0.pdf')">
        <div class="ding-regimeList-left">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/PDF_icon.svg" alt="">
        </div>
        <div class="ding-regimeList-right">
          <p class="ding-regimeList-p1"><span>CP_001_V1.0 FOSUN Supplier Code of Conduct V1.0</span>.pdf</p>
          <p class="ding-regimeList-p2">2020-08-07</p>
        </div>
      </li>
      <li @click="toPath('http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/CP_002_V1.0%20%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E4%BE%9B%E5%BA%94%E5%95%86%E8%AF%9A%E4%BF%A1%E7%AE%A1%E7%90%86%E5%AE%9E%E6%96%BD%E7%BB%86%E5%88%99%EF%BC%88%E8%AF%95%E8%A1%8C%EF%BC%89.pdf')">
        <div class="ding-regimeList-left">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/PDF_icon.svg" alt="">
        </div>
        <div class="ding-regimeList-right">
          <p class="ding-regimeList-p1"><span>CP_002_V1.0 复星集团供应商诚信管理实施细则（试行）</span>.pdf</p>
          <p class="ding-regimeList-p2">2020-08-07</p>
        </div>
      </li>
      <li @click="toPath('http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/CP_001_V1.0%20%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E4%BE%9B%E5%BA%94%E5%95%86%E8%A1%8C%E4%B8%BA%E5%87%86%E5%88%99%20V1.0%20.pdf')">
        <div class="ding-regimeList-left">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/PDF_icon.svg" alt="">
        </div>
        <div class="ding-regimeList-right">
          <p class="ding-regimeList-p1"><span>CP_001_V1.0 复星集团供应商行为准则 V1.0</span>.pdf</p>
          <p class="ding-regimeList-p2">2020-08-07</p>
        </div>
      </li> -->
    </ul>

    <div class="ding-regimeList-tit mt30">学习资料</div>
    <ul>
      <!-- <a v-for="item in fileList" :key="item.id" :href="item.fileUrl" target="_blank"> -->
        <li  v-for="item in fileList2" :key="item.id" @click="toPath(item.fileUrl, item, 1)" >
          <!-- <li
              v-for="item in fileList"
              :key="item.id" @click="preview(item)"> -->
            <div class="ding-regimeList-left">
              <img v-if="item.fileType=='.jpg'" src="http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/JPG_icon.svg" alt="">
              <img v-else src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/PDF_icon.svg" alt="">
            </div>
            <div class="ding-regimeList-right">
              <p class="ding-regimeList-p1"><span>{{item.fileName}}</span>{{item.fileType}}</p>
              <!-- <p class="ding-regimeList-p1">
                <pdf src="./static/pdf/%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E9%87%87%E8%B4%AD%E7%99%BD%E7%9A%AE%E4%B9%A6V2.0.pdf"></pdf>
              </p> -->
              <p class="ding-regimeList-p2">{{item.time}}</p>
            </div>
        </li>
    </ul>
    <el-dialog
      title="文件预览"
      :visible.sync="dialogVisible2"
      width="90%"
      @closed="closeDialog"
      custom-class="magnifer-dialog"
    >
      <div ref="printContent" class="magnifer">
        <Pdf
          v-for="i in numPages"
          :key="i"
          :src="src"
          :page="i"
        />
        <!-- <iframe class="prism-player" :src="pdfUrl" width="100%" height="100%"></iframe> -->
        <!-- <iframe class="regime-iframe" :src="url" frameborder="0" style="width: 100%; height: 100%"></iframe> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible2=false">取消</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
  // import Pdf from 'vue-pdf'
  import * as customSensors from '@/assets/js/sensors'

  export default {
    props: [],
    data () {

      return {
        pdfUrl:"http://static.onelinkplus.com/p/onelink.mdata.main.ui/pdf/AR_T_CP%E2%80%A200_001_V2.0%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E9%87%87%E8%B4%AD%E6%8B%9B%E6%A0%87%E7%AE%A1%E7%90%86%E5%88%B6%E5%BA%A6V2.0.pdf",
        fileList: [
          {
            id: 1,
            fileName: '复星集团采购白皮书V2.0',
            fileUrl: `http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E9%87%87%E8%B4%AD%E7%99%BD%E7%9A%AE%E4%B9%A6V2.0.pdf`,
            time:'2018-07'
          },
          {
            id: 2,
            fileName: 'AR_T_CP•00_001_V2.0复星集团采购招标管理制度V2.0',
            fileUrl: `http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/AR_T_CP%E2%80%A200_001_V2.0%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E9%87%87%E8%B4%AD%E6%8B%9B%E6%A0%87%E7%AE%A1%E7%90%86%E5%88%B6%E5%BA%A6V2.0.pdf`,
            time:'2018-07-25'
          },
          {
            id: 3,
            fileName: 'AR_S_CP•00_005_V1.0复星集团采购招标管理细则V1.0',
            fileUrl: `http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/AR_S_CP%E2%80%A200_005_V1.0%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E9%87%87%E8%B4%AD%E6%8B%9B%E6%A0%87%E7%AE%A1%E7%90%86%E7%BB%86%E5%88%99V1.0.pdf`,
            time:'2018-07-25'
          },
          {
            id: 4,
            fileName: 'CP_001_V1.0 FOSUN Supplier Code of Conduct V1.0',
            fileUrl: `http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/CP_001_V1.0%20FOSUN%20Supplier%20Code%20of%20Conduct%20V1.0.pdf`,
            time:'2019-11-22'
          },
          {
            id: 5,
            fileName: 'CP_002_V1.0 复星集团供应商诚信管理实施细则（试行）',
            fileUrl: `http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/CP_002_V1.0%20%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E4%BE%9B%E5%BA%94%E5%95%86%E8%AF%9A%E4%BF%A1%E7%AE%A1%E7%90%86%E5%AE%9E%E6%96%BD%E7%BB%86%E5%88%99%EF%BC%88%E8%AF%95%E8%A1%8C%EF%BC%89.pdf`,
            time:'2019-11-22'
          },
          {
            id: 6,
            fileName: 'CP_001_V1.0 复星集团供应商行为准则 V1.0',
            fileUrl: `http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/CP_001_V1.0%20%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E4%BE%9B%E5%BA%94%E5%95%86%E8%A1%8C%E4%B8%BA%E5%87%86%E5%88%99%20V1.0%20.pdf`,
            time:'2019-11-22'
          }
        ],
        url:'',
        numPages: undefined,
        dialogVisible2: false,
        fileList2:[
          {
            id: 1,
            fileName: '青铜到王者——采招篇',
            fileUrl: `http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/%E9%9D%92%E9%93%9C%E5%88%B0%E7%8E%8B%E8%80%85%E2%80%94%E2%80%94%E9%87%87%E6%8B%9B%E7%AF%87.jpg`,
            time:'2020-05-21',
            fileType:'.jpg'
          },
          {
            id: 2,
            fileName: '一链网修改项目数据规范2020版',
            fileUrl: `http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/%E4%B8%80%E9%93%BE%E7%BD%91%E4%BF%AE%E6%94%B9%E9%A1%B9%E7%9B%AE%E6%95%B0%E6%8D%AE%E8%A7%84%E8%8C%832020%E7%89%88.pdf`,
            time:'2020-06-19',
            fileType:'.pdf'
          },
          {
            id: 3,
            fileName: '一链网系统数据调取输出规范2020版V1.1',
            fileUrl: `http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/%E4%B8%80%E9%93%BE%E7%BD%91%E7%B3%BB%E7%BB%9F%E6%95%B0%E6%8D%AE%E8%B0%83%E5%8F%96%E8%BE%93%E5%87%BA%E8%A7%84%E8%8C%832020%E7%89%88V1.1.pdf`,
            time:'2020-01-21',
            fileType:'.pdf'
          },
          {
            id: 4,
            fileName: '采购商相关操作Q&A',
            fileUrl: `http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/%E9%87%87%E8%B4%AD%E5%95%86%E7%9B%B8%E5%85%B3%E6%93%8D%E4%BD%9CQ%26A.pdf`,
            time:'2020-08-31',
            fileType:'.pdf'
          }
        ]
      }
    },
    components: {
      // Pdf
    },
    created () {
      // 这儿的url就是静态资源pdf的访问地址
      // let url = 'http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/CP_001_V1.0 复星集团供应商行为准则 V1.0 .pdf'
      // this.pdfUrl = `/static/pdf/web/viewer.html?file=${encodeURIComponent(url)}`
       var pdfUrl = "http://test.onelinkplus.com/static/pdf/AR_T_CP%E2%80%A200_001_V2.0%E5%A4%8D%E6%98%9F%E9%9B%86%E5%9B%A2%E9%87%87%E8%B4%AD%E6%8B%9B%E6%A0%87%E7%AE%A1%E7%90%86%E5%88%B6%E5%BA%A6V2.0.pdf";

        this.$axios({
            type: "get",
            // data: {"param": pdfUrl},
            async: false,
            mimeType: 'text/plain; charset=x-user-defined',
            url: pdfUrl
        }).then((data)=>{
          console.info(data,atob(data))
          // var pdfData = atob(data);
          // // Using DocumentInitParameters object to load binary data.
          // var loadingTask = PDFJS.getDocument({data: pdfData});
          // loadingTask.promise.then(function (pdf) {
          //     console.log('PDF loaded');
          //     var pageCountNum = pdf.numPages;
          //     pdfView = pdf;
          //     for (var i = 1; i <= pageCountNum; i++) {
          //         addPage(i);
          //     }
          // }, function (reason) {
          //     console.error(reason);
          // });
        });
    },
    mounted () {

    },
    methods: {

      // 预览
      preview(item, type=1) {
        // this.numPages=undefined
        if(type==2){
          this.url=item.fileUrl
          this.dialogVisible2 = true
        }else{

           var headers = {

              'Authorization': 'Bearer SOME_TOKEN',

              'x-ipp-device-uuid': 'SOME_UUID',

              'x-ipp-client': 'SOME_ID',
              'x-ipp-client-version': 'SOME_VERSION'

          };

          this.src = Pdf.createLoadingTask({
            url:item.fileUrl,
            httpHeaders:headers
          })
          this.src.promise.then(pdf => {
            this.numPages = pdf.numPages
          })
          this.dialogVisible2 = true
        }
      },
      closeDialog(){
        this.dialogVisible2 = false
        this.numPages=undefined
      },
      toPath(url, item, type){
        try {
          customSensors.customDocumentlistclick({
            document_type: type == 1 ? '学习资料' : '规章制度',
            document_name: item.fileName
          })
        } catch (e) {}
        setTimeout(()=>{
           window.location.reload()
        },1000)
        window.open(url)
      }
    }
  }
</script>
<style>
  .regime-iframe::-webkit-scrollbar {
      width: 5px;
      height: 5px;
  }
  .regime-iframe::-webkit-scrollbar-thumb{
      background-color: #999;
      -webkit-border-radius: 5px;
      border-radius: 5px;
  }
  .regime-iframe::-webkit-scrollbar-thumb:vertical:hover{
      background-color: #666;
  }
  .regime-iframe::-webkit-scrollbar-thumb:vertical:active{
      background-color: #333;
  }
  .regime-iframe::-webkit-scrollbar-button{
      display: none;
  }
  .regime-iframe::-webkit-scrollbar-track{
      background-color: #f1f1f1;
  }
</style>


// WEBPACK FOOTER //
// src/pages/dingWorkbench/regimeList.vue